// Export the Component Definition for use in Contentful Studio
export {OverlineContentfulComponentDefinition} from './OverlineContentfulDefinition';
export {default} from './Overline';
